import React from "react";

function ProblemsConstraints() {
  return <div>ProblemsConstraints</div>;
}

export default ProblemsConstraints;
